<template>
  <div v-if="!!classroomMaterialDto || classroomMaterialDto != []">
    <div
      v-for="classMaterial in classroomMaterialDto"
      :key="classMaterial.idType"
    >
      <div
        :class="{
          'blocco_sfumato cf cancel-button': !isUsedInsideNewReservedArea,
        }"
      >
        <div class="titolo title">{{ classMaterial.nameType }}</div>
        <div class="row-fluid">
          <DxDataGrid :data-source="classMaterial.classroomMaterials">
            <DxPaging :enabled="true"></DxPaging>
            <DxColumn
              alignment="left"
              data-field="materialType"
              caption="Titolo"
              cell-template="titleTemplate"
            ></DxColumn>
            <DxColumn
              alignment="center"
              data-field="loadDate"
              caption="Data"
              data-type="date"
              :width="150"
            ></DxColumn>
            <DxColumn
              alignment="center "
              data-field="url"
              caption="Download"
              cell-template="loadButtonTemplate"
              :width="150"
            ></DxColumn>
            <template #loadButtonTemplate="{ data }">
              <div>
                <DxButton
                  styling-mode="contained"
                  :text="data.data.extension"
                  type="default"
                  @click="goToCourse(data)"
                >
                </DxButton>
              </div>
            </template>
            <template #titleTemplate="{ data }">
              <div>
                <strong>{{ data.data.materialType }}</strong> -
                {{ data.data.materialName }}
              </div>
              <div></div>
            </template>
          </DxDataGrid>
        </div>
      </div>
      <br />
    </div>
  </div>
</template>
<script>
import { DxDataGrid, DxColumn, DxPaging } from 'devextreme-vue/data-grid'
import { DxButton } from 'devextreme-vue/button'
export default {
  name: 'EcClassroomMaterial',
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxButton,
  },
  props: {
    dayIdFromNewReservedArea: {
      type: Number,
      default: -1,
    },
    siteIdFromNewReservedArea: {
      type: Number,
      default: -1,
    },
    sourceRequestFromNewReservedArea: {
      type: String,
      default: 'SitoWeb',
    },
    isUsedInsideNewReservedArea: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dayId: null,
      siteId: null,
      sourceRequest: null,
      classroomMaterialDto: null,
    }
  },
  created() {
    console.log('EcClassroomMaterial created')
    const classroomMaterial = document.querySelector('#ec-classroom-material')
    if (classroomMaterial) {
      this.dayId = classroomMaterial.getAttribute('dayId')
      this.siteId = classroomMaterial.getAttribute('siteId')
      this.sourceRequest = classroomMaterial.getAttribute('sourceRequest')
    } else {
      this.dayId = this.dayIdFromNewReservedArea
      this.siteId = this.siteIdFromNewReservedArea
      this.sourceRequest = this.sourceRequestFromNewReservedArea
    }
  },
  mounted() {
    const classroomMaterial = document.querySelector('#ec-classroom-material')
    if (classroomMaterial) {
      return this.loadMaterials()
    } else {
      return this.loadMaterials()
    }
  },
  methods: {
    loadMaterials() {
      return this.apiService.trainingProductsApiService
        .getClassroomMaterial(this.dayId, this.siteId, this.sourceRequest)
        .then(res => {
          this.classroomMaterialDto = res
        })
    },
    goToCourse(data) {
      var url = window.location.origin + '/' + data.data.url
      window.open(url, '_blank')
    },
  },
}
</script>
<style scoped>
.table-header {
  text-transform: uppercase;
  text-align: left;
  background: #00a0dc;
  color: white;
  padding: 10px;
  font: 14px/14px pt_sansregular;
}
.dx-button.dx-button-default {
  border-radius: 25px;
}
.subelement-headers {
  margin-top: 25px;
}
</style>
